
import React, { useEffect,useContext,useState } from "react";
import {  Button, Modal } from 'react-bootstrap';

import Context from '../../_helpers/context';
import functions from "../../_helpers/functions"


import StepEta from "../../forms/form_step_eta"
import StepCity from "../../forms/form_step_city"
import StepUsername from "../../forms/form_step_username"
import StepPsw from "../../forms/form_step_psw"
import StepEmail from "../../forms/form_step_email"
import StepPsw_Email from "../../forms/form_step_psw_mail"
import StepCerco from "../../forms/form_step_cerco"

import './offer2.css'
const lang = require('./lang/lang.json')
const config = require("../../../config.json"); 
const domain = window.location.hostname;

export default function Offer2() {

  const context = useContext(Context)

 
  const locale = context.lang
  const [bottoneFinale, setBottoneFinale] = useState(context.voluum_domain);
  const [errore, setErrore] = useState({});
  const [erroreDaBackend, setErroreDaBackend] = useState(null);
  
  const setupDomande = [
 
    {
      tipologia:"form",
      controllo_campo:["cerco"],
      sottologo:"PER CHI VUOLE INCONTRI AUTENTICI",
      slogan:"I nuovi profili sono più visibili e fanno match più facilmente",
      sotto_slogan:require("./img/group.png"),
      percentuali_1:{perc:76, colore:"#2CE080", dicitura:"76%", titolo:"Probabilità di questo abbinamento"},
      percentuali_2:{perc:90, colore:"#0074cc", dicitura:"4093", titolo:"Numero di potenziali partner"},
      domanda:"Chi vuoi conoscere?",
      step:"form_step_cerco",
      pulsanti:0
    },
    {
      tipologia:"form",
      controllo_campo:["city"],
      sottologo:"PER CHI VUOLE INCONTRI AUTENTICI",
      slogan:"L'87% degli iscritti trova incontri significativi entro una settimana",
      sotto_slogan:require("./img/donne_gruppo.png"),
      percentuali_1:{perc:76, colore:"#2CE080", dicitura:"81%", titolo:"Probabilità di questo abbinamento"},
      percentuali_2:{perc:90, colore:"#0074cc", dicitura:"992", titolo:"Numero di potenziali partner"},
      domanda:"In quale città vuoi contattare le donne?",
      step:"form_step_city",
      testo_bottone:"Continua",
      pulsanti:1
    },
    {
      tipologia:"form",
      controllo_campo:["eta"],
      sottologo:"PER CHI VUOLE INCONTRI AUTENTICI",
      slogan:"Profili verificati per garantire chat sicure",
      sotto_slogan:require("./img/donne_gruppo2.png"),
      percentuali_1:{perc:76, colore:"#2CE080", dicitura:"89%", titolo:"Probabilità di questo abbinamento"},
      percentuali_2:{perc:90, colore:"#0074cc", dicitura:"631", titolo:"Numero di potenziali partner"},
      domanda:"Qual è la tua età?",
      step:"form_step_eta",
      testo_bottone:"Continua",
      pulsanti:1
    },
    {
      tipologia:"avviso",
      step:"form_step_username",
      controllo_campo:["username"],
      sottologo:"PER CHI VUOLE INCONTRI AUTENTICI",
      slogan:"Abbiamo trovato 631<br>abbinamenti perfetti per te!",
      percentuali_1:{perc:76, colore:"#2CE080", dicitura:"89%", titolo:"Probabilità di questo abbinamento"},
      percentuali_2:{perc:90, colore:"#0074cc", dicitura:"631", titolo:"Numero di potenziali partner"},
      domanda:"Scrivi il tuo Username",
      testo_bottone:"Continua",
      pulsanti:1
    },
    {
      tipologia:"avviso",
      sottologo:"PER CHI VUOLE INCONTRI AUTENTICI",
      slogan:"Visto i 631 abbinamenti, ti abbiamo regalato crediti di benvenuto per chattare.",
      sotto_slogan:require("./img/sordi.png"),
      percentuali_1:{perc:76, colore:"#2CE080", dicitura:"89%", titolo:"Probabilità di questo abbinamento"},
      percentuali_2:{perc:90, colore:"#0074cc", dicitura:"631", titolo:"Numero di potenziali partner"},
      testo_bottone:"Continua",
      pulsanti:1
    },
    {
      tipologia:"avviso",
      step:"form_step_psw_mail",
      sottologo:"PER CHI VUOLE INCONTRI AUTENTICI",
      slogan:"⚠️ATTENZIONE⚠️",
      avviso:"Inserisci la tua Email principale per completare la registrazione:",
      avviso_sottolineato:"Riceverai subito una mail di verifica che dovrai cliccare per conoscere tutte le donne della community.",
      piccolino:"N.B. Se non clicchi sulla mail NON potrai vedere tutte le donne disponibili.",
      percentuali_1:{perc:76, colore:"#2CE080", dicitura:"89%", titolo:"Probabilità di questo abbinamento"},
      percentuali_2:{perc:90, colore:"#0074cc", dicitura:"631", titolo:"Numero di potenziali partner"},
      testo_bottone:"ENTRA ORA",
      controllo_campo:["email","password"],
      pulsanti:1
    },
   
    
  ]
   

    const [step, setStep] = useState(0);
    const [domande, setDomande] = useState(setupDomande);
  

    useEffect(()  => {
        document.body.classList.add('offer2');
       
    });


   

  function RenderStepForm(){

    if(domande[step].tipologia == "avviso"){
      return (
        <div className="domandaCheckbox avviso">
          <div className="responsive-container">
              <div className="logo_container">
                <img src={context.remoteLogo}/>
              </div>
              <div className="sottoLogo">
                <span>{domande[step].sottologo}</span>
              </div>
              
            <div className="column left-column">
                 {domande[step].sotto_slogan && (
                    <div className="sottoSlogan">
                      <img src={domande[step].sotto_slogan} width={"350px"}/>
                    </div>
                  )}
                  
                  
                <h3 dangerouslySetInnerHTML={{ __html: domande[step].slogan }}></h3>

                {domande[step].avviso && (
                    <div className="raccomandazione">
                      <span>{domande[step].avviso}</span>
                    </div>
                  )}

                {domande[step].avviso_sottolineato && (
                    <div className="sottolineato">
                      <span>{domande[step].avviso_sottolineato}</span>
                    </div>
                  )}
                
                {domande[step].piccolino && (
                    <div className="piccolino">
                      <span>{domande[step].piccolino}</span>
                    </div>
                  )}

                <div className="avviso">
                  <div className="domanda">
                    {domande[step].domanda}
                  </div>
                </div>
            </div>
            <div className="column right-column">
            <div className="form-container">
               
                <div className="domanda">
                  {domande[step].domanda}
                </div>
                <div className="step">
                  {scegliStep()}
                </div>
                {erroreDaBackend && (
                  <div className="errore">{erroreDaBackend}</div>
                )}
                <div className="pulsanti">
                  <StampaPulsanti/>
                </div>
                
            </div>
            </div>
          </div>
        </div>
        
        )
    }

    return (<div className="domandaCheckbox">
      <div className="responsive-container">
        <div className="column left-column">
          <div className="logo_container">
            <img src={context.remoteLogo}/>
          </div>
          <div className="sottoLogo">
            <span>{domande[step].sottologo}</span>
            
          </div>
          <div className="slogan">
            <span>{domande[step].slogan}</span>
          </div>
        </div>

        <div className="column right-column">
          <div className="sottoSlogan">
            <img src={domande[step].sotto_slogan} width={"350px"}/>
          </div>

          <div className="percentuali">
              <span class="progress-bar__name">{domande[step].percentuali_1.titolo}</span>
              <strong><span class="progress-bar__value">{domande[step].percentuali_1.dicitura}</span></strong>
              <ProgressBar percentage={domande[step].percentuali_1.perc} color={domande[step].percentuali_1.colore} />
          </div>
          <div className="percentuali">
              <span class="progress-bar__name">{domande[step].percentuali_2.titolo}</span>
              <strong><span class="progress-bar__value">{domande[step].percentuali_2.dicitura}</span></strong>
              <ProgressBar percentage={domande[step].percentuali_2.perc} color={domande[step].percentuali_2.colore} />
          </div>
        </div>

        <div className="form-container">
            <div className="domanda">
              {domande[step].domanda}
            </div>
            <div className="step">
              {scegliStep()}
            </div>
            <div className="pulsanti">
              <StampaPulsanti/>
            </div>
          
        </div>
    </div>
      
        
      
    </div>)
  }


  function scegliStep(){

  
      switch(domande[step].step) {
        case 'form_step_eta':
          return <StepEta { ... errore}/>;
        case 'form_step_city':
          return <StepCity { ... errore}/>;
        case 'form_step_username':
          return <StepUsername { ... errore}/>;
        case 'form_step_psw':
          return <StepPsw { ... errore}/>;
        case 'form_step_email':
          return <StepEmail { ... errore}/>;
        case 'form_step_psw_mail':
          return <StepPsw_Email { ... errore}/>;
        case 'form_step_cerco':
          return <StepCerco onStep={()=>{setStep(prev => prev+1)}} { ... errore}/>;
      
      }

  }


  const StepBody = () => {


      return RenderStepForm()



  }


  function controllaErroriCampi(){
    var campi_errati = { ...errore }
    var check = true
    for(let i=0;i<domande?.[step]?.controllo_campo?.length;i++){
      if(!context.user_form[domande[step].controllo_campo[i]]){
        campi_errati[domande[step].controllo_campo[i]] = true
        setErrore(campi_errati)
        check = false
      }else{
        campi_errati[domande[step].controllo_campo[i]] = false
        setErrore(campi_errati)
      }
    }
    
    if(!check){
      return false
    }else{
      setErrore({})
      return true
    }
    
  }


  function StampaPulsanti(){
      if(domande[step].pulsanti == 1){
        return (<div className="contieniPulsanti">
        <Button onClick={() => { 
  
            const check = controllaErroriCampi()
              if(check){
                if(step !== Object.keys(domande).length -1 ){
                  setStep(prev => prev+1) 
                }else{
                  submitLead()
                }
              }
       
        }
          
        } className="unico">{domande[step].testo_bottone}</Button>

        {domande[step].terms && (<label className="terms"><input type="checkbox" defaultChecked={true}></input>{domande[step].terms}</label>)}
      </div>)
      }
    
    
    return <></>
  }

  

  async function submitLead(){
    var search = window.location.search.substring(1)
    
    if(search){
      const query = JSON.parse('{"' + search.replace(/&/g, '","').replace(/=/g,'":"') + '"}', function(key, value) { return key===""?value:decodeURIComponent(value) })
      context.user_form = {...context.user_form , ... query}
    }

    console.log(context.user_form )
    const res = await functions.submitLead(context.user_form,locale)
    if(res.success){
      window.location.replace(res.red_url+"&"+window.location.search.replace('?', ''))
    }else{
      console.log("submitLead error - ",res.message)
      setErroreDaBackend(res.message)
    }
  }

  function ProgressBar({ percentage, color }) {
    // Validazione opzionale in JavaScript
    const validPercentage = typeof percentage === 'number' && percentage >= 0 && percentage <= 100 ? percentage : 0;
    const validColor = typeof color === 'string' ? color : '#e0e0e0'; // Colore di default se non valido
  
    return (
      <div className="progress-bar-container">
        <div
          className="progress-bar"
          style={{
            width: `${validPercentage}%`,
            backgroundColor: validColor,
          }}
        ></div>
      </div>
    );
  }
  

  useEffect(() => {

   try{
    if(window.deviceFingerprint){
      functions.trackUser(window.deviceFingerprint,context).then(response=>{
        if(response){
          setBottoneFinale(response)
        }
      })
    }
   }catch(e){
    console.log("Track user error - ",e)
   }  
    

  },[window.deviceFingerprint]); 



	return ( <div className="offer2" style={{backgroundColor:"#111",backgroundSize:'cover'}}>
    
 
      <StepBody/>

     
   
      </div>);


}